import { Deal } from '../core/types/Deal';

export const sendTrackingPixelRequests = (deals: Deal[]): void => {
  const uniqueTrackingUrls = [
    ...new Set(deals.flatMap((deal) => (deal.tracking_pixel_url ? [deal.tracking_pixel_url] : []))),
  ];
  const timestamp = Date.now().toString();
  const timestampedTrackingUrls = uniqueTrackingUrls.map((url) =>
    url.replace('hawk-cache', timestamp),
  );
  timestampedTrackingUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};
